import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-primary text-subtitle2 text-uppercase q-mb-sm" }, " Daily Reminders ", -1)
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-7" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "col text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_reminders_btn = _resolveComponent("toggle-reminders-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.request.remindersEnabled)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " The client is receiving daily reminders to import their " + _toDisplayString(_ctx.platform) + " posts. ", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, " The client is not receiving daily reminders to import their " + _toDisplayString(_ctx.platform) + " posts. ", 1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_toggle_reminders_btn, {
          request: _ctx.request,
          "onUpdate:request": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:request', $event)))
        }, null, 8, ["request"])
      ])
    ])
  ]))
}